// Action types
const SET_DASHBOAD_SEARCH_DATA = "SET_DASHBOAD_SEARCH_DATA";
const CLEAR_DASHBOAD_SEARCH_DATA = "CLEAR_DASHBOAD_SEARCH_DATA";

export type DashboardSearchState =
  | {
      selectedTab: string;
      searchTerm: string;
      selectedDevelopers?: string[];
      selectedCity?: {
        name: string;
        value: string;
        type: string;
      }[];
      selectedValues?: {
        name: string;
        value: string;
        type: string;
      }[];
    }
  | {};

// Initial state
const initialState: { dashboardSearchData: DashboardSearchState } = {
  dashboardSearchData: {
    selectedTab: null,
    selectedCity: null,
    selectedDevelopers: null,
    selectedValues: null,
    searchTerm: null,
  },
};

// Action creators

export const setDashboardSearchData = (searchData: DashboardSearchState) => ({
  type: SET_DASHBOAD_SEARCH_DATA,
  payload: searchData,
});
export const clearDashboardSearchData = () => ({
  type: CLEAR_DASHBOAD_SEARCH_DATA,
  payload: {},
});

// Reducer
export const dashboadSearchReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_DASHBOAD_SEARCH_DATA:
      return {
        ...state,
        dashboardSearchData: action.payload,
      };
    case CLEAR_DASHBOAD_SEARCH_DATA:
      return {
        ...state,
        dashboardSearchData: action.payload,
      };

    default:
      return state;
  }
};

export default dashboadSearchReducer;
